export enum InsuranceFileType {
    Policy = 0,
    Cancellation = 1,
}
